import { useQuery } from '@ts-core/lib/apollo';

import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';
import { ProfessorActivityAnswer } from '../types';

import { getActivityAnswersQuery, GetActivityAnswersQueryResult, GetActivityAnswersQueryVariables } from '../graphql/queries/getActivityAnswersQuery';

interface ActivityAnswersHookInput {
  courseId: string;
  activityId: string;
}

interface ActivityAnswersHookPayload {
  answers?: ProfessorActivityAnswer[];
  loading: boolean;
}

export default function useActivityAnswers(input: ActivityAnswersHookInput): ActivityAnswersHookPayload {
  const { courseId, activityId } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading } = useQuery<GetActivityAnswersQueryResult, GetActivityAnswersQueryVariables>(getActivityAnswersQuery, {
    variables: { courseId, activityId },
    fetchPolicy: 'cache-and-network',
    onError: showErrorNotification,
  });

  return {
    answers: data?.answers,
    loading,
  };
}
